import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	gap: 20px;
	grid-gap: 20px;

	& > div > div > label {
		color: ${tokens.color_gray_dark};
		font-weight: 500;
	}
`;

export const ExamContainer = styled.div`
	display: grid;
	gap: 10px;
	grid-gap: 10px;

	#exam-label {
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: -0.28px;
		color: ${tokens.color_gray_dark};
	}
`;

export const ExamTitle = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	gap: 8px;
	grid-gap: 8px;
	align-items: center;
	height: 40px;

	& > button {
		height: 40px;
	}
`;

export const SelectContainer = styled.div<{ height?: string }>`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 45px;
	grid-gap: 45px;
	height: ${({ height }) => height || '66px'};
`;

export const OtherSection = styled.div`
	display: flex;
	align-items: end;
	gap: 8px;

	.input-frequency-other {
		& > input {
			height: 35px;
		}
	}
`;
